<template>
  <b-alert
    :show="show"
    dismissible
  >
    You should be using Google Chrome.
    <a :href="href">
      Learn More
    </a>
  </b-alert>
</template>

<script>
  import { detect } from 'detect-browser'
  const browser = detect()

  export default {
    props: {
      href: {
        type: String,
        required: true,
      },
    },
    computed: {
      show() {
        return browser && browser.name !== 'chrome' && browser.name !== 'ios'
      },
    },
  }
</script>